import type { SpacingType } from '@sdk/components/ui/spacing/SpacingStyle';

import { Container } from './expiryBanner.styles';

type Props = {
  text: string;
  type: 'warning' | 'danger';
} & SpacingType;

const ExpiryBanner = ({ text, ...rest }: Props) => {
  return <Container {...rest}>{text}</Container>;
};

export default ExpiryBanner;
